import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/admin/compound/developer-templates";
const apiUploadFileEndpoint = API_BASE_URL_ENV() + "/admin/compound/sheet-headings";
const apiTogglle = API_BASE_URL_ENV() + "/admin/compound/toggle-activation/DeveloperTemplate";
const apiImportTemplate = API_BASE_URL_ENV() + "/admin/compound/units-template-import";

export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }

    getDropDown=()=>{
        return  http.get(apiDropDownEndpoint) 
    }
   
    getColumns = (selectedFile) =>{
        const formData = new FormData();
        formData.append("selectedFile", selectedFile);
        return http.post(apiUploadFileEndpoint, formData)
    }

    changeStatus(id) {
        return http.get(`${apiTogglle}/${id}`);
    }

    importTemplates=(data)=>{
        return http.post(apiImportTemplate, data)
    }

}
